<template>
  <section id="app-scan-keyboard">
    <!-- ********************************
    ********** LISTE DE BADGES **********
    ********************************* -->
    <scrollable action>
      <v-btn
        v-for="(card, i) in cards"
        :key="i"
        x-large
        block
        class="mb-2"
        @click="startScan(card.NumBadge)"
      >
        {{ card.Texte }}
      </v-btn>
    </scrollable>

    <bottom-action
      v-if="cards.length > 0"
      btn-cancel
      btn-valid-disabled
      @del="del"
      @cancel="cancel"
    />
    <keyboard-code
      v-else
      v-model="code"
      name="keyboard-scan"
      :use-listener="useListener"
      @input="sendCode"
      @del="del"
      @cancel="cancel"
      @valid="valid"
    />
  </section>
</template>

<script>
import { Scan } from '@/modules/Scan'
import { $alert } from '@/modules/Utils'
import { ActionEnum } from '@/modules/Enums'

export default {
  name: 'KeyboardScan',

  props: {
    action: { type: Number, default: null },
    useListener: { type: Boolean, default: true },
    useSearch: { type: Boolean, default: true },
    idNomCarte: { type: Number, default: null }
  },

  data () {
    return {
      badgeNumber: '',
      cards: [],
      code: ''
    }
  },

  methods: {
    // ********** KEYBOARD **********
    sendCode (code) {
      this.$emit('code', code)
    },
    del () {
      if (this.cards.length > 0) {
        this.cards = []
        this.$emit('show')
      } else {
        this.$emit('del')
      }
    },
    cancel () {
      this.$emit('cancel')
    },

    /**
     * Validation d'un numéro de badge
     */
    valid () {
      // Recherche de la liste des cartes disponibles avec le numéro court saisi
      if (this.code.length >= 4) {
        if (!this.useSearch) {
          this.$emit('scan', this.code, 'MAN')
          return
        }

        Scan.longnumber(
          this.code,
          this.action === ActionEnum.giftReset ? 'R' : 'C',
          this.idNomCarte,
          (response) => {
            // Si une seule carte et que l'on n'est pas en train de faire de la fid alors envoi du seul numéro long à scan()
            if (response.length === 1 && this.action !== ActionEnum.loyalty) {
              this.startScan(response[0].NumBadge)
            } else {
              this.cards = response
              this.$emit('hide')
              this.$store.commit('loader', false)
            }
          },
          (error) => {
            this.code = ''
            this.$emit('code', '')
            $alert(error)
            this.$store.commit('loader', false)
          }
        )
      }
    },
    startScan (numero) {
      this.cards = []
      this.code = ''
      this.$emit('code', '')
      this.$emit('show')
      this.$emit('scan', numero, 'MAN')
    }
  }
}
</script>
